const donationPosts = [
  {
    slug: "obitelj-kolak",
    title: "Pomoć obitelji Kolak nakon požara",
    subtitle: "Zajedno obnavljamo njihov dom",
    amount: "247,48 €",
    excerpt:
      "Nakon požara koji je teško oštetio njihov dom, kroz dvije donacije pomogli smo obitelji Kolak u nabavi materijala potrebnog za nastavak obnove.",
          coverImage: "np-materijali/donacije/kolak/1.jpg",

          images: [
            "np-materijali/donacije/kolak/2.jpg",
            "np-materijali/donacije/kolak/4.jpg",
            "np-materijali/donacije/kolak/5.jpg",
            "np-materijali/donacije/kolak/3.jpg",
          ],

    intro: [
      "Jedan trenutak dovoljan je da se svakodnevni život potpuno promijeni. Obitelj Kolak to je doživjela 22. kolovoza 2025. godine, kada je požar teško oštetio njihov obiteljski dom. Srećom, nitko nije stradao, ali iza požara ostala je velika materijalna šteta i dom kojem je bila potrebna temeljita obnova.",

      "Upravo je njihova priča jedna od onih zbog kojih postoji humanitarni projekt Najam polaroida – projekt kroz koji uspomene naših korisnika pretvaramo u konkretnu pomoć ljudima kojima je ona potrebna.",
    ],

    sections: [
      {
        heading: "Od najma instant kamera do konkretnog materijala za obnovu",
        paragraphs: [
          "Zahvaljujući svima koji su unajmili naše instant kamere i tako podržali projekt, za obnovu doma obitelji Kolak osigurali smo sredstva za kupnju potrebnog građevinskog materijala.",

          "U rujnu 2025. godine donirano je 131,98 eura za materijal za Knauf, potreban za obnovu stambenog prostora.",

          "No pomoć tu nije završila.",

          "Nekoliko mjeseci kasnije ponovno smo se uključili u obnovu doma te smo osigurali dodatnih 115,50 eura za nabavu laminata i materijala potrebnog za njegovo postavljanje.",

          "Kroz ove dvije donacije obitelji Kolak osigurano je ukupno 247,48 eura pomoći za obnovu doma nakon požara.",
        ],
      },

      {
            heading: "Humanitarni stand-up za obitelj Kolak",

            image: "np-materijali/donacije/kolak/kolak-standup.jpg",

            imageAlt: "Humanitarni stand-up Best of Hercegovina za obitelj Kolak",

            imageCaption: "Humanitarni stand-up „Best of Hercegovina“",

            paragraphs: [
              "Priča obitelji Kolak okupila je i širu zajednicu.",

              "Kako bismo prikupili dodatna sredstva za pomoć, organiziran je humanitarni stand-up show „Best of Hercegovina“. Prihod od prodaje ulaznica usmjeren je obitelji Kolak i nabavi materijala potrebnog za nastavak obnove njihovog doma.",

              "Ova akcija još jednom je pokazala koliko se može postići kada se oko zajedničkog cilja okupe ljudi spremni pomoći – bilo najmom kamere, kupnjom ulaznice, donacijom ili jednostavno širenjem priče.",
            ],
          },
      {
        heading: "Fotografija koja postaje dobro djelo",
        paragraphs: [
          "Ideja projekta Najam polaroida od samog je početka jednostavna: trenutke sreće pretvoriti u pomoć onima koji prolaze kroz teške životne okolnosti.",

          "Najmom naših instant kamera ne nastaje samo fotografija i uspomena. Dio sredstava koje projekt prikupi usmjeravamo u konkretne humanitarne akcije – od pomoći u obnovi domova stradalih u požarima i drugim nesrećama do hrane, režijskih troškova i drugih osnovnih životnih potreba.",

          "Pomoć obitelji Kolak zato nije samo priča o doniranih 247,48 eura. To je priča o tome što se može dogoditi kada velik broj malih trenutaka sreće postane dio jednog većeg dobrog djela.",
        ],
      },

      {
        heading: "Zajedno možemo više",
        paragraphs: [
          "Obnova doma nakon požara dug je proces, a svaka pomoć znači još jedan korak prema povratku normalnom životu.",

          "Hvala svima koji su do sada unajmili naše kamere, sudjelovali u humanitarnim događanjima, podijelili naše objave ili na drugi način podržali projekt Najam polaroida.",

          "Jer iza svake fotografije može stajati puno više od uspomene. Može stajati nečiji novi početak.",
        ],
      },
    ],
  },


  {
    slug: "obitelj-uremovic",
    title: "Pomoć obitelji Uremović u teškim životnim okolnostima",
    subtitle: "Tri donacije za ono najpotrebnije",
    amount: "294,42 €",
    date: "2026-08-23",
    excerpt:
      "Kroz tri donacije obitelji Uremović pomogli smo podmiriti račune za struju te osigurati hranu i osnovne životne potrepštine.",

   coverImage: "np-materijali/donacije/uremovic/1.jpg",

      images: [
        "np-materijali/donacije/uremovic/4.jpg",
        "np-materijali/donacije/uremovic/2.jpg",
        "np-materijali/donacije/uremovic/3.jpg",
        "np-materijali/donacije/uremovic/standup.jpg",
      ],

    intro: [
      "Ponekad pomoć ne znači velike stvari. Ponekad znači plaćen račun za struju, hranu na stolu i osjećaj da u teškom trenutku ipak niste sami.",

      "Upravo je takva bila pomoć obitelji Uremović, kojoj smo kroz humanitarni projekt Najam polaroida u nekoliko navrata osigurali sredstva za osnovne životne potrebe.",

      "Njihov dom nalazio se u vrlo lošem stanju, a urušavanje dijela stropa dodatno je otežalo ionako zahtjevnu svakodnevicu. Uz nesigurne uvjete stanovanja, obitelj se suočavala i s troškovima koje više nije mogla samostalno podmirivati.",
    ],

    sections: [
      {
        heading: "Kada račun za struju postane velika briga",
        paragraphs: [
          "Jedna od najhitnijih potreba obitelji bilo je podmirivanje računa za električnu energiju kako njihov dom ne bi ostao bez struje.",

          "Sredstvima prikupljenima kroz projekt Najam polaroida najprije smo osigurali 96,35 eura za podmirivanje računa za struju, a potom još 57,47 eura za sljedeću ratu.",

          "Možda su to iznosi koji na prvi pogled ne djeluju veliki. Međutim, obitelji koja se istodobno suočava s nesigurnim domom i nedostatkom sredstava za osnovne potrebe, plaćen račun znači jednu brigu manje.",
        ],
      },

      {
        heading: "Pomoć nije završila plaćanjem računa",
        paragraphs: [
          "Nakon pomoći s troškovima električne energije nastavili smo pratiti potrebe obitelji Uremović.",

          "Kroz humanitarni stand-up događaj prikupljeno je dodatnih 140,60 eura, koje smo usmjerili za hranu i druge potrebne potrepštine za kućanstvo.",

          "Tako je kroz tri donacije obitelji Uremović osigurano ukupno 294,42 eura pomoći.",

          "Iza tog iznosa kriju se vrlo konkretne stvari – struja u domu, osnovne namirnice i barem malo financijskog rasterećenja u razdoblju u kojem je svaka pomoć bila važna.",
        ],
      },

      {
        heading: "Najam polaroida – male uspomene koje stvaraju veliku pomoć",
        paragraphs: [
          "Projekt Najam polaroida nastao je iz želje da lijepe trenutke pretvorimo u nešto što može pomoći i drugima.",

          "Svaki najam instant kamere doprinosi stvaranju sredstava koja možemo usmjeriti ljudima i obiteljima suočenima s teškim životnim okolnostima. Nekada je to materijal za obnovu doma nakon požara, a nekada račun za struju, hrana ili druga osnovna potreba.",

          "Upravo nam priča obitelji Uremović pokazuje koliko konkretna i pravovremena pomoć može značiti.",
        ],
      },

      {
        heading: "Zajedno možemo učiniti više",
        paragraphs: [
          "Iza svake kamere koja je bila dio nečijeg vjenčanja, proslave ili drugog posebnog trenutka nalazi se još jedna mala prilika za dobro djelo.",

          "Zahvaljujući svima koji podržavaju projekt Najam polaroida, možemo nastaviti prepoznavati obitelji kojima je pomoć potrebna i pretvarati prikupljena sredstva u ono što im u tom trenutku najviše znači.",

          "Jer ponekad promjena ne počinje velikim gestama. Ponekad počinje jednim plaćenim računom, punijim stolom i spoznajom da netko misli na vas.",
        ],
      },
    ],
  },


  {
    slug: "obitelj-tintor",
    title: "Pomoć obitelji Tintor nakon požara",
    subtitle: "Podrška na putu prema novom domu",
    amount: "651,90 €",
    date: "2026-08-23",
    excerpt:
      "Nakon požara u kojem su izgubili svoj dom, obitelji Tintor kroz tri smo donacije pomogli s osnovnim životnim troškovima, grijanjem privremenog smještaja i troškovima liječenja.",

    coverImage: "np-materijali/donacije/tintor/5.jpg",

      images: [
        "np-materijali/donacije/tintor/1.jpg",
        "np-materijali/donacije/tintor/2.jpg",
        "np-materijali/donacije/tintor/3.jpg",
        "np-materijali/donacije/tintor/8.jpg",
      ],

    intro: [
      "U noći 13. siječnja 2026. godine život obitelji Tintor iz Gline promijenio se u svega nekoliko trenutaka. Mala iskra iz utičnice prerasla je u požar koji im je uništio dom. Zidovi, stvari i osjećaj sigurnosti koji pruža vlastiti dom nestali su gotovo preko noći.",

      "Srećom, svi članovi obitelji ostali su živi i neozlijeđeni. No pred njima je ostalo puno teže pitanje – kako ponovno izgraditi svakodnevni život kada od doma gotovo ništa nije ostalo?",

      "Zahvaljujući sredstvima prikupljenima kroz projekt Najam polaroida, obitelji Tintor pomagali smo u nekoliko navrata, prateći njihove potrebe tijekom razdoblja nakon požara.",
    ],

    sections: [
      {
        heading: "Prva pomoć nakon gubitka doma",
        paragraphs: [
          "Nakon požara obitelj je najprije bila smještena kod članova obitelji, a potom u kontejneru u kojem je čekala izgradnju novog doma.",

          "U prvim tjednima nakon nesreće bilo je potrebno osigurati ono najosnovnije. Zato smo u siječnju obitelji Tintor donirali 190 eura za troškove života i hranu.",

          "U situaciji u kojoj je potrebno krenuti gotovo ispočetka, takva pomoć znači mogućnost da se barem dio svakodnevnih potreba podmiri dok se obitelj pokušava prilagoditi potpuno novim okolnostima.",
        ],
      },

      {
        heading: "Topliji privremeni dom dok čekaju novi početak",
        paragraphs: [
          "Kako je obitelj privremeno živjela u kontejneru, pojavila se još jedna konkretna potreba – grijanje.",

          "U veljači smo zato osigurali dodatnih 421,90 eura za kupnju klime, kako bi prostor u kojem obitelj boravi bio topliji i ugodniji dok čekaju izgradnju novog doma.",

          "Klima je kupljena izravnom uplatom na račun trgovine, čime su sredstva projekta Najam polaroida ponovno pretvorena u konkretnu pomoć tamo gdje je u tom trenutku bila najpotrebnija.",
        ],
      },

      {
        heading: "Ostali smo uz obitelj Tintor",
        paragraphs: [
          "Naša pomoć nije završila jednom donacijom.",

          "U ožujku smo obitelji osigurali još 40 eura za troškove pregleda sina u Zagrebu.",

          "Kroz tri donacije tako je obitelji Tintor iz projekta Najam polaroida osigurano ukupno 651,90 eura pomoći.",

          "Svaka od tih donacija odgovorila je na drugačiju potrebu – od hrane i svakodnevnih troškova, preko toplijeg privremenog smještaja, do zdravstvenih potreba jednog člana obitelji.",
        ],
      },

      {
        heading: "Najam polaroida pretvara uspomene u konkretnu pomoć",
        paragraphs: [
          "Projekt Najam polaroida temelji se na jednostavnoj ideji: trenutke sreće koje ljudi bilježe našim instant kamerama pretvoriti i u priliku da pomognemo nekome drugome.",

          "Sredstva prikupljena najmom kamera usmjeravamo u konkretne humanitarne akcije i potrebe obitelji koje su se našle u teškim životnim okolnostima.",

          "Priča obitelji Tintor pokazuje zašto nam je važno da pomoć ne mora završiti jednom donacijom. Život nakon požara ne vraća se u normalu preko noći, a potrebe se mijenjaju kako obitelj prolazi kroz različite faze oporavka.",
        ],
      },

      {
        heading: "Svaki najam može postati dio nečijeg novog početka",
        paragraphs: [
          "Iza svake fotografije snimljene našom kamerom može stajati još jedna priča – ona koju možda nikada nećete vidjeti na fotografiji, ali kojoj ste svojim najmom pomogli.",

          "Hvala svima koji podržavaju projekt Najam polaroida i omogućuju nam da nastavimo pomagati.",

          "Za obitelj Tintor ta je podrška do sada značila 651,90 eura konkretne pomoći i tri koraka prema sigurnijoj svakodnevici nakon požara.",

          "A mi njihovu priču nastavljamo pratiti na putu prema novom domu.",
        ],
      },
    ],
  },


  {
    slug: "blagdanska-pomoc",
    title: "Blagdanska pomoć obiteljima: božićni i uskrsni darovi",
    subtitle: "Da blagdani budu topliji za sve",
    amount: "916,88 €",
    date: "2026-08-23",
    excerpt:
      "Obiteljima kojima smo pomagali tijekom godine za Božić smo pripremili pakete s hranom i potrepštinama, a povodom Uskrsa poklon-bonove za kupnju onoga što im je najpotrebnije.",

   coverImage: "np-materijali/donacije/blagdani/2.jpg",
coverPosition: "center 45%",



video: "np-materijali/donacije/blagdani/blagdani-video.mp4",
    intro: [
      "Blagdani su vrijeme zajedništva, obiteljskih okupljanja i malih znakova pažnje. No obiteljima koje se suočavaju s financijskim poteškoćama upravo to razdoblje može donijeti i dodatne brige.",

      "Zato smo kroz projekt Najam polaroida željeli učiniti nešto više za obitelji kojima smo pomagali tijekom godine – pokazati im da na njih mislimo i onda kada neposredna humanitarna akcija završi.",

      "Za božićne i uskrsne darove obiteljima izdvojili smo ukupno 916,88 eura, prikupljenih zahvaljujući svima koji podržavaju projekt Najam polaroida.",
    ],

    sections: [
      {
        heading: "Božićni paketi za obitelji kojima smo pomagali",
        paragraphs: [
          "Uoči Božića pripremili smo pakete za obitelji koje su tijekom godine bile dio naših humanitarnih akcija.",

          "Umjesto simboličnih darova, željeli smo im pokloniti nešto što će im zaista koristiti. Paketi su zato sadržavali prehrambene proizvode i druge potrepštine koje mogu barem malo olakšati svakodnevicu i pripremu blagdanskog stola.",

          "Za nabavu božićnih paketa iz sredstava projekta izdvojili smo ukupno 416,88 eura.",

          "Iza tog iznosa nisu samo proizvodi u paketima. Iza njega je poruka svakoj obitelji kojoj smo ih uručili – nismo vas zaboravili.",
        ],
      },

      {
        heading: "Za Uskrs smo pomoć prepustili izboru samih obitelji",
        paragraphs: [
          "Povodom Uskrsa odlučili smo napraviti nešto malo drugačije.",

          "Umjesto unaprijed pripremljenih paketa, obiteljima smo osigurali poklon-bonove ukupne vrijednosti 500 eura kako bi same mogle odabrati i kupiti ono što im je u tom trenutku najpotrebnije.",

          "Nekome će to biti namirnice za blagdanski stol, nekome higijenske ili kućanske potrepštine, a nekome nešto što već neko vrijeme nedostaje u domu.",

          "Na taj smo način željeli pružiti pomoć koja nije samo konkretna, nego i prilagođena stvarnim potrebama svake obitelji.",
        ],
      },

      {
        heading: "Pomoć koja ne završava jednom donacijom",
        paragraphs: [
          "Kroz projekt Najam polaroida upoznali smo obitelji koje su se našle u različitim teškim životnim okolnostima – od gubitka doma i posljedica požara do financijskih poteškoća i problema s podmirivanjem osnovnih životnih troškova.",

          "Kada nekome pomognemo, ne želimo da ta pomoć nužno završi jednom uplatom.",

          "Božićni paketi i uskrsni poklon-bonovi naš su način da obiteljima kojima smo već pružili podršku pokažemo da ih se sjećamo i da ostajemo uz njih i nakon prve akcije.",
        ],
      },

      {
        heading: "Najam polaroida – uspomene koje pomažu drugima",
        paragraphs: [
          "Svaki najam instant kamere kroz projekt Najam polaroida doprinosi stvaranju fonda iz kojeg možemo financirati ovakve i druge humanitarne akcije.",

          "Fotografije tako ostaju uspomena ljudima koji slave svoje posebne trenutke, dok dio vrijednosti svakog najma nastavlja svoj put prema obiteljima kojima je pomoć potrebna.",

          "Zahvaljujući svima koji su do sada bili dio projekta, za božićne pakete i uskrsne poklon-bonove izdvojili smo 916,88 eura.",

          "No vrijednost ovih blagdanskih darova za nas nije samo u iznosu.",

          "Ona je u osjećaju da zajedništvo koje povezujemo s blagdanima možemo prenijeti i izvan vlastitih domova – do ljudi kojima mali znak pažnje u pravom trenutku može značiti mnogo.",

          "Hvala svima koji svojim najmom, podrškom i dijeljenjem naših priča omogućuju da nastavimo pretvarati uspomene u dobra djela.",
        ],
      },
    ],
  },


  
    {
  slug: "danijela-bares",
  title: "Pomoć Danijeli Bareš i njezinim djevojčicama",
  subtitle: "Kad zajedništvo znači novi početak",
  amount: "660,00 €",
  date: "2026-08-23",

  excerpt:
    "U suradnji s Udrugom Sretno odrastanje uključili smo se u pomoć majci dviju djevojčica te osigurali sredstva za račun za plin, hranu i osnovne životne potrepštine.",

  coverImage: "np-materijali/donacije/danijela-bares/1.jpg",
coverPosition: "center",

images: [
  "np-materijali/donacije/danijela-bares/1.jpg",
  "np-materijali/donacije/danijela-bares/2.jpg",
  "np-materijali/donacije/danijela-bares/3.jpg",
],
  intro: [
    "Ponekad su dovoljna samo tri dana da se pokaže koliko veliko srce imaju ljudi kada se netko nađe u teškoj životnoj situaciji.",

    "Danijela Bareš majka je dviju djevojčica koja se, nakon niza teških životnih okolnosti, našla u situaciji u kojoj je sama morala osigurati sigurnost svojoj djeci i podmiriti osnovne životne potrebe.",

    "Za njezinu smo priču saznali zahvaljujući humanitarnoj akciji Udruge Sretno odrastanje – USOIHST. Kada smo vidjeli njihovu inicijativu, odlučili smo se uključiti i dio sredstava prikupljenih kroz projekt Najam polaroida usmjeriti upravo Danijeli i njezinoj obitelji.",
  ],

  sections: [
    {
      heading: "Prvo smo pomogli podmiriti račun za plin",
      paragraphs: [
        "Jedna od najvećih briga s kojima se Danijela u tom trenutku suočavala bio je račun za plin pred isključenjem.",

        "Zahvaljujući svima koji su unajmljivali naše instant kamere i time podržavali projekt Najam polaroida, mogli smo brzo reagirati.",

        "Izdvojili smo 560 eura za podmirenje računa za plin, kako bi Danijela i njezine djevojčice zadržale ono što bi u svakom domu trebalo biti osnovno – siguran i topao prostor za život.",
      ],
    },

    {
      heading: "Nakon računa, napunili smo i košaricu",

      gallery: [
        "np-materijali/donacije/danijela-bares/3.jpg",
        "np-materijali/donacije/danijela-bares/4.jpg",
      ],

      
      paragraphs: [
        "Znali smo da podmirivanje jednog računa neće riješiti sve probleme s kojima se ova obitelj suočava.",

        "Zato smo nakon prve donacije osigurali još 100 eura za hranu i najpotrebnije namirnice.",

        "Kroz dvije donacije iz projekta Najam polaroida Danijeli Bareš i njezinoj obitelji tako smo osigurali ukupno 660 eura pomoći.",

        "Iako novac ne može riješiti svaku životnu poteškoću, može u pravom trenutku ukloniti barem jednu veliku brigu – osigurati grijanje, napuniti hladnjak i pružiti malo prostora za novi početak.",
      ],
    },

    {
      heading: "Suradnjom možemo pomoći više",
      paragraphs: [
        "Ova priča za nas ima još jednu važnu dimenziju.",

        "Do Danijele smo došli zahvaljujući radu Udruge Sretno odrastanje – USOIHST, koja je pokrenula humanitarnu akciju kako bi joj pomogla u teškom razdoblju.",

        "Upravo ovakve suradnje pokazuju koliko povezivanje humanitarnih inicijativa, udruga i ljudi koji žele pomoći može imati konkretan rezultat.",

        "Netko prepozna potrebu. Netko pokrene akciju. Netko je podijeli. A netko svojim najmom instant kamere, možda i ne znajući kome će sredstva jednoga dana biti potrebna, omogući da pomoć zaista stigne do osobe kojoj treba.",
      ],
    },

    {
      heading: "Najam polaroida – fotografije koje postaju pomoć",
      paragraphs: [
        "Projekt Najam polaroida temelji se upravo na toj ideji.",

        "Naše instant kamere putuju na vjenčanja, proslave i druge trenutke koje ljudi žele sačuvati. No nakon što fotografije ostanu kao uspomena, dio sredstava prikupljenih najmom nastavlja svoj put.",

        "Pretvara se u građevinski materijal za obitelj koja je izgubila dom, plaćeni račun za nekoga kome prijeti isključenje, hranu za obiteljski stol ili neku drugu konkretnu pomoć.",

        "U slučaju Danijele i njezinih djevojčica, taj je put završio s 660 eura pomoći za plin, hranu i osnovne životne potrebe.",
      ],
    },

    {
      heading: "Iza svake pomoći stoje ljudi",
      paragraphs: [
        "Najveća vrijednost ove priče ipak nije samo u iznosu koji smo donirali.",

        "Ona je u tome što se u pravom trenutku povezalo više ljudi oko istog cilja – pomoći jednoj majci da svojoj djeci osigura sigurniju svakodnevicu.",

        "Hvala Udruzi Sretno odrastanje na pokretanju akcije i svima koji su na bilo koji način sudjelovali u njoj.",

        "A posebno hvala svima koji podržavaju Najam polaroida. Svakim najmom omogućujete nam da nastavimo pratiti ovakve priče i, kada možemo, pretvorimo vaše trenutke sreće u nečiji razlog za novu nadu.",
      ],
    },
  ],
},

  {
    slug: "matija-farkas",
    title: "Pomoć Matiji Farkašu u uređenju doma za oporavak",
    subtitle: "Zajedno stvaramo sigurnije mjesto za povratak kući",
    amount: "510,94 €",
    date: "2026-08-23",
    excerpt:
      "U suradnji s Udrugom Roditelji za djecu uključili smo se u uređenje doma za Matijin oporavak te osigurali sredstva za nove prozore, laminat i potreban materijal.",

    coverImage: "np-materijali/donacije/matija-farkas/matija-cover.jpg",
      coverPosition: "center",

        images: [],

        video: "np-materijali/donacije/matija-farkas/matija-video.mp4",
    intro: [
      "Ponekad pomoć znači stvoriti uvjete da se netko nakon teškog životnog razdoblja može vratiti u siguran i uređen dom.",

      "Upravo nas je takva priča povezala s Matijom Farkašem i Udrugom Roditelji za djecu, koja je pokrenula humanitarnu akciju kako bi se uredio prostor potreban za Matijin oporavak nakon transplantacije pluća.",

      "Kada smo saznali za akciju, odlučili smo se uključiti. Sredstva prikupljena kroz projekt Najam polaroida usmjerili smo u konkretne radove na domu – one koji će Matiji pomoći osigurati primjerenije uvjete za povratak i oporavak.",
    ],

    sections: [
      {
        heading: "Dom koji treba biti spreman za Matijin povratak",
        paragraphs: [
          "Udruga Roditelji za djecu pokrenula je akciju uređenja prostora u kojem bi se Matija trebao oporavljati nakon transplantacije.",

          "Bilo je potrebno urediti zidove, podove i druge dijelove prostora te osigurati materijal potreban za završetak radova.",

          "Kada je potrebno obnoviti dom, svaki dovršeni dio znači korak bliže cilju. Zato smo odlučili pomoći upravo ondje gdje je u tom trenutku bilo potrebno.",
        ],
      },

      {
        heading: "Dvije donacije za uređenje prostora",
        paragraphs: [
          "Prvom donacijom iz projekta Najam polaroida izdvojili smo 300 eura za kupnju dva nova PVC prozora.",

          "Nakon toga nastavili smo pratiti napredak radova i potrebe obitelji.",

          "Za nastavak uređenja osigurali smo još 210,94 eura za kupnju laminata i pomoćnog materijala potrebnog za njegovo postavljanje.",

          "Kroz dvije donacije tako smo za uređenje Matijina doma izdvojili ukupno 510,94 eura.",

          "Prozori i pod možda na prvi pogled izgledaju kao samo još jedan dio građevinskih radova. U ovoj priči oni znače nešto mnogo važnije – stvaranje prostora u kojem će Matija imati bolje uvjete za oporavak i povratak svakodnevnom životu.",
        ],
      },

      {
        heading: "Zajedno s Udrugom Roditelji za djecu",
        paragraphs: [
          "Ova pomoć još je jedan primjer koliko se više može napraviti kada se povežu ljudi i udruge s istim ciljem.",

          "Udruga Roditelji za djecu prepoznala je Matijinu potrebu, pokrenula akciju i okupila zajednicu oko uređenja njegova doma. Mi smo se kroz Udrugu Lice sreće i projekt Najam polaroida uključili financiranjem dijela potrebnog materijala.",

          "Dok su jedni pomagali radom, drugi materijalom, donacijama ili dijeljenjem priče, svaki je doprinos vodio prema istom cilju – završiti prostor kako bi Matija imao mjesto u kojem se može oporavljati.",
        ],
      },

      {
        heading: "Najam polaroida pretvara lijepe trenutke u konkretnu pomoć",
        paragraphs: [
          "Iza obje naše donacije ponovno stoje svi koji su barem jednom unajmili instant kameru kroz projekt Najam polaroida.",

          "Ideja projekta je jednostavna: trenuci koje ljudi žele sačuvati fotografijom istodobno mogu pomoći u stvaranju nečijeg boljeg sutra.",

          "Prikupljena sredstva zato usmjeravamo prema konkretnim potrebama – od pomoći obiteljima nakon požara i podmirivanja osnovnih životnih troškova do, kao u Matijinu slučaju, uređenja prostora potrebnog za oporavak.",

          "Ovoga puta vaši najmovi postali su dva nova prozora, laminat i materijal za uređenje doma.",
        ],
      },

      {
        heading: "Svaki završeni dio doma korak je bliže cilju",
        paragraphs: [
          "Matijina priča podsjeća nas da iza svake humanitarne akcije postoji vrlo konkretan cilj.",

          "U ovom slučaju to nije samo obnovljen prostor. Cilj je dom spreman dočekati Matiju i pružiti mu što bolje uvjete za oporavak.",

          "Hvala Udruzi Roditelji za djecu na pokretanju akcije i svima koji su svojim radom, donacijama i podrškom sudjelovali u uređenju doma.",

          "Hvala i svima koji podržavaju Najam polaroida. Zahvaljujući vama, u ovu smo priču mogli ugraditi 510,94 eura konkretne pomoći – i još jednom pokazati koliko velike stvari mogu nastati iz mnoštva malih dobrih djela.",
        ],
      },
    ],
  },
];

export default donationPosts;